<template>
<v-container fill-height fluid>
	<v-card class="mx-auto">
		<CourseList></CourseList>
	</v-card>	

</v-container>
</template>

<script>
import CourseList from './CourseList'

export default {
	name: 'Courses',
	components: { CourseList },

}
</script>